export interface AnalyticsUrl {
  ios: string;
  android: string;
}

export function getAnalyticsUrl(): AnalyticsUrl {
  if (document.location.host === process.env.REACT_APP_DOMAIN_NAME_FR) {
    return {
      ios: 'https://apps.apple.com/app/apple-store/id1597755165?pt=1948947&ct=gcx-clientiagpca-login-sticky&mt=8',
      android: 'https://iaprivatewealth.ca/mobile-app-store-redirect',
    };
  }

  return {
    ios: 'https://apps.apple.com/app/apple-store/id1597755165?pt=1948947&ct=gcx-clientiapwca-login-sticky&mt=8',
    android: 'https://iaprivatewealth.ca/mobile-app-store-redirect',
  };
}
